export function getValueAt(object: any, path: string): any {
  const pathParts = path.split('.');

  return pathParts.reduce((agg, item) => (agg || {})[item], object);
}

export function getValueAtWithArrays(object: any, path: string): any {
  const pathParts = path.split('.');

  let current = object;
  for (const part of pathParts) {
    current = getValue(current, part);
    if (current === undefined || current === null) {
      return undefined;
    }
  }

  return current;
}

export function updateObjProp (obj: any, value: any, propPath: string) {
  const [head, ...rest] = propPath.split('.');

  if (!rest.length) {
    obj[head] = value;
  } else {
    updateObjProp(obj[head], value, rest.join('.'));
  }
}

export function getValue(object: any, prop: string): any {
  if (!object) {
    return undefined;
  } else if (Array.isArray(object)) {
    return object.map((o) => getValue(o, prop));
  } else {
    return object[prop];
  }
}

export function compareObjects( x: any, y: any ) {
  if ( x === y ) return true;
  // if both x and y are null or undefined and exactly the same

  if ( ! ( x instanceof Object ) || ! ( y instanceof Object ) ) return false;
  // if they are not strictly equal, they both need to be Objects

  if ( x.constructor !== y.constructor ) return false;
  // they must have the exact same prototype chain, the closest we can do is
  // test there constructor.

  for ( var p in x ) {
      if ( ! x.hasOwnProperty( p ) ) continue;
      // other properties were tested using x.constructor === y.constructor

     if ( ! y.hasOwnProperty( p ) ) return false;
     // allows to compare x[ p ] and y[ p ] when set to undefined

     if ( x[ p ] === y[ p ] ) continue;
     // if they have the same strict value or identity then they are equal

     if ( typeof( x[ p ] ) !== "object" ) return false;
     // Numbers, Strings, Functions, Booleans must be strictly equal

     if ( ! compareObjects( x[ p ],  y[ p ] ) ) return false;
     // Objects and Arrays must be tested recursively
 }

 for (var pY in y ) {
    if ( y.hasOwnProperty( pY ) && ! x.hasOwnProperty( pY ) ) return false;
    // allows x[ p ] to be set to undefined
  }
  return true;
}